import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';

import './layout-modal.scss';

class Layout extends React.Component {
  close = () => {
    if (this.props.previousHref) {
      window.history.back();

      if (window.history.length === 1) {
        navigate(this.props.to);
      }
    } else {
      navigate(this.props.to);
    }
  }

  render() {
    const { children, className, style } = this.props;
    const { close } = this;

    return pug`
      .layout-modal(className=className, style=style)
        .layout-modal__close.hidden-print(onClick=close) &times;
        .max-width-container=children
    `;
  }
}

Layout.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  previousHref: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Layout;
